import { useCallback, useEffect, useState } from "react";
import {
  loadSOrdnerOverviewBundle,
  type SOrdnerOverviewBundle,
} from "@/lib/sordnerOverview";

export function useSOrdnerOverviewData(sordnerId: number | null, enabled: boolean) {
  const [data, setData] = useState<SOrdnerOverviewBundle | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const refetch = useCallback(async () => {
    if (!enabled || !sordnerId) return;
    setLoading(true);
    setError(null);
    try {
      const bundle = await loadSOrdnerOverviewBundle(sordnerId);
      setData(bundle);
    } catch (err) {
      setError(err instanceof Error ? err.message : "S-Ordner konnte nicht geladen werden.");
    } finally {
      setLoading(false);
    }
  }, [enabled, sordnerId]);

  useEffect(() => {
    if (!enabled || !sordnerId) {
      setData(null);
      setError(null);
      setLoading(false);
      return;
    }
    void refetch();
  }, [enabled, sordnerId, refetch]);

  return { data, loading, error, refetch };
}
